import { render, staticRenderFns } from "./WidgetHeader.vue?vue&type=template&id=18bc12bc&"
import script from "./WidgetHeader.vue?vue&type=script&lang=js&"
export * from "./WidgetHeader.vue?vue&type=script&lang=js&"
import style0 from "./WidgetHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VIcon,VSpacer,VToolbar,VToolbarTitle})
